export default "__VITE_ASSET__d1a974ef__"